import React from 'react'
import { Switch, Route, useRouteMatch, useHistory } from "react-router-dom"
import { SolicitudesAsignadasAdminPage } from './admin/SolicitudesAsignadasAdminPage'
import { CadenasPage } from './cadenas/CadenasPage';
import SolicitudAsignadaDetailPage from './detail/SolicitudAsignadaDetailPage';

const SolicitudesAsignadasRoutes = () => {
  const { path } = useRouteMatch();
  const history = useHistory()

  return (
    <Switch>
      <Route path={`${path}/solicitudes-asignadas-admin`} render={(props) => (<SolicitudesAsignadasAdminPage {...props} history={history} />)} />
      <Route path={`${path}/solicitudes-asignadas/cadenas/:id`} render={(props) => (<CadenasPage {...props} cadena='Matriz Agua' history={history} />)} />
      <Route path={`${path}/solicitudes-asignadas/:id`} component={SolicitudAsignadaDetailPage} />
    </Switch>
  )
}
export default SolicitudesAsignadasRoutes;
